export default __webpack_public_path__ + "static/media/noisebg.ce3463ff.png";